const form = {
  formId: "tax-personal-10",
  formField: {
    fullName2: {
      name: "fullName2",
      label: "[06] Họ và tên vợ(chồng) nếu có",
      type: "text",
      placeholder: "",
    },
    identity: {
      name: "identity",
      label: "[07] Số CMND/CCCD/Số hộ chiếu vợ(chồng)",
      type: "text",
      placeholder: "",
    },
    taxCalculationPeriod: {
      name: "taxCalculationPeriod",
      label: "[01] Kỳ tính thuế:",
      type: "number",
      placeholder: "01/2023",
      errorMsg: "Vui lòng chọn kỳ tính thuế",
    },
    firstTime: {
      name: "firstTime",
      label: "[02] Lần đầu",
      type: "text",
    },
    checkbox1: {
      name: "checkbox1",
      label:
        "Tờ khai quyết toán thuế làm theo hồ sơ giảm thuế do thiên tai, hỏa hoạn, tai nạn, bệnh hiểm nghèo",
      type: "text",
    },
    supplementaryForThe: {
      name: "supplementaryForThe",
      label: "[03] Bổ sung lần thứ",
      type: "number",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập bổ sung lần thứ",
      invalidMsg: "Số không hợp lệ",
    },
    fromMonth: {
      name: "fromMonth",
      label: "Từ tháng",
      type: "number",
      errorMsg: "Vui lòng chọn",
    },
    toMonth: {
      name: "toMonth",
      label: "Đến tháng",
      type: "number",
      errorMsg: "Vui lòng chọn",
    },
    caseAccounting: {
      name: "caseAccounting",
      label: "Trường hợp quyết toán",
      type: "text",
      errorMsg: "Vui lòng nhập trường hợp quyết toán",
    },
    taxpayerName: {
      name: "taxpayerName",
      label: "[04] Người nộp thuế",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập tên người nộp thuế",
    },
    taxId1: {
      name: "taxId1",
      label: "[05] Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    address: {
      name: "address",
      label: "[06] Địa chỉ",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập địa chỉ",
    },
    province: {
      name: "province",
      label: "[08] Tỉnh/Thành phố",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn Tỉnh / Thành phố",
    },
    district: {
      name: "district",
      label: "[07] Quận/Huyện",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn",
    },
    organizationName: {
      name: "organizationName",
      label: "[15] Tên tổ chức trả thu nhập",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập địa chỉ",
    },
    taxId2: {
      name: "taxId2",
      label: "[16] Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    address2: {
      name: "address2",
      label: "[17] Địa chỉ",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập địa chỉ",
    },
    province2: {
      name: "province2",
      label: "[19] Tỉnh/Thành phố",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn Tỉnh / Thành phố",
    },
    district2: {
      name: "district2",
      label: "[18] Quận/Huyện",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng chọn",
    },
    phone: {
      name: "phone",
      label: "[09] Điện thoại",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập số điện thoại",
      invalidMsg: "Số điện thoại không hợp lệ",
    },
    fax: {
      name: "fax",
      label: "[10] Fax",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập fax",
    },
    email: {
      name: "email",
      label: "[11] Email",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập email",
      invalidMsg: "Email không hợp lệ",
    },
    taxAgencyName: {
      name: "taxAgencyName",
      label: "[12] Tên đại lý thuế (nếu có)",
      type: "text",
      placeholder: "",
    },
    taxAgencyId: {
      name: "taxAgencyId",
      label: "[13] Mã số thuế đại lý",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mst đại lý",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    moneyRefund: {
      name: "moneyRefund",
      label: "Số tiền hoàn trả (đồng)",
      type: "text",
      placeholder: "",
    },
    typeRefund: {
      name: "typeRefund",
      label: "Hình thức hoàn trả",
      type: "text",
    },
    ownerBankName: {
      name: "ownerBankName",
      label: "Tên chủ tài khoản",
      type: "text",
      placeholder: "",
    },
    accountNumber: {
      name: "accountNumber",
      label: "Số tài khoản",
      type: "text",
      placeholder: "",
    },
    bankName: {
      name: "bankName",
      label: "Tại ngân hàng/KBNN",
      type: "text",
      placeholder: "",
    },
    receiverName: {
      name: "receiverName",
      label: "Tên người nhận tiền",
      type: "text",
      placeholder: "",
    },
    receiverNameId: {
      name: "receiverNameId",
      label: "CMND/CCCD/HC số",
      type: "text",
      placeholder: "",
    },
    date: {
      name: "date",
      label: "Ngày cấp",
      type: "text",
      placeholder: "",
    },
    place: {
      name: "place",
      label: "Nơi cấp",
      type: "text",
      placeholder: "",
    },
    inventory: {
      name: "inventory",
      label: "Kho bạc nhà nước",
      type: "text",
      placeholder: "",
    },

    fullName: {
      name: "fullName",
      label: "Họ và tên nhân viên đại lý thuế",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập họ và tên",
    },
    certificate: {
      name: "certificate",
      label: "Chứng chỉ hành nghề số:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập chứng chỉ hành nghề số",
    },
    signer: {
      name: "signer",
      label: "Người ký",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập người ký",
    },
    timeSign: {
      name: "timeSign",
      label: "Ngày ký",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày ký",
    },
  },
};

export default form;
